import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Login.css';

const providerOptions = [
  {
    key: 'ciam',
    label: 'KCS Connect account',
    subtitle: 'Sign in or create your account',
    loginPath: '/.auth/login/ciam',
  },
];

const localDevTestUsers = [
  {
    email: 'phil@knowknot.com',
    label: 'KCS Super User (Phil Robinson)',
  },
  {
    email: 'admin@whiteglovespro.com',
    label: 'White Gloves Provider Super Admin',
  },
];

const Login = () => {
  const {
    user,
    hasRealSession,
    isLocalDevMode,
    signInForDevelopment,
    signOutLocalDevelopment,
    logoutUrl,
  } = useAuth();

  const handleSignOut = () => {
    if (hasRealSession) {
      window.location.href = logoutUrl;
      return;
    }

    signOutLocalDevelopment();
  };

  if (user) {
    return (
      <div className="login-page">
        <div className="login-card">
          <h1>Already signed in</h1>
          <p>You are currently signed in as {user.userDetails || 'a user'}.</p>
          <Link to="/provider/dashboard" className="provider-button">Go to dashboard</Link>
          <button type="button" className="provider-button" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Sign in to KCS Connect+</h1>
        <p className="login-copy">Sign in or create your KCS Connect account.</p>

        <div className="provider-list">
          {providerOptions.map((provider) => (
            <a key={provider.key} href={provider.loginPath} className="provider-button">
              <span>{provider.label}</span>
              <small>{provider.subtitle}</small>
            </a>
          ))}
        </div>

        <p className="login-footnote">Use the email address associated with your KCS Connect account.</p>

        {isLocalDevMode && (
          <div className="dev-login-panel">
            <h2>Local development access</h2>
            <p>Use this only for localhost testing when SSO is not available.</p>
            <div className="provider-list">
              {localDevTestUsers.map((devUser) => (
                <button
                  key={devUser.email}
                  type="button"
                  className="provider-button"
                  onClick={() => {
                    signInForDevelopment(devUser.email);
                    window.location.href = '/provider/dashboard';
                  }}
                >
                  <span>{devUser.label}</span>
                  <small>{devUser.email}</small>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
